export function PrivacyPolicyPage() {
  return (
    <>
      <h1>Privacy Policy</h1>

      <h2>1. Introduction</h2>
      <p>
        This Privacy Policy explains how spcfy GmbH (&ldquo;we&ldquo;, &ldquo;our&ldquo;, &ldquo;us&ldquo;) collects, processes, and protects personal data when users interact with our platform at www.spcfy.io.
      </p>
      <p>
        We are committed to safeguarding your privacy and ensuring compliance with the General Data Protection Regulation (GDPR) and other applicable data protection laws.
      </p>

      <h2>2. Controller Information</h2>
      <p>
        spcfy GmbH<br />
        Niemeyerstraße 1<br />
        04179 Leipzig<br />
        Germany<br />
        Email: info@spcfy.io
      </p>

      <h2>3. Categories of Data We Process</h2>
      <h3>a) Account and Contact Data</h3>
      <ul>
        <li>Name</li>
        <li>Email address</li>
        <li>Institution or company (optional)</li>
        <li>Login credentials (hashed)</li>
      </ul>
      <h3>b) Usage and Access Data</h3>
      <ul>
        <li>IP address</li>
        <li>Device/browser type</li>
        <li>Access logs and timestamps</li>
        <li>User activity on the platform (e.g., uploads, analysis actions)</li>
      </ul>
      <h3>c) Uploaded Files and Metadata</h3>
      <ul>
        <li>Sequencing files (e.g., FASTQ files from Illumina machines)</li>
        <li>Associated metadata (e.g., habitat type, coordinates, laboratory protocols)</li>
        <li>Customer-defined sample IDs and annotations</li>
        <li>Note: FASTQ files and metadata may contain sensitive ecological or location-related information, but do not contain personal data by default.</li>
      </ul>

      <h2>4. Purpose and Legal Basis of Processing</h2>
      <p>We process data for the following purposes:</p>
      <table className="table table-zebra">
        <thead>
        <tr>
          <th>Purpose</th>
          <th>Legal Basis (Art. 6 GDPR)</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>User registration and login</td>
          <td>Art. 6(1)(b) – Contract</td>
        </tr>
        <tr>
          <td>Performing bioinformatic analyses</td>
          <td>Art. 6(1)(b) – Contract</td>
        </tr>
        <tr>
          <td>Long-term data storage and access</td>
          <td>Art. 6(1)(b) – Contract</td>
        </tr>
        <tr>
          <td>Improving services and infrastructure</td>
          <td>Art. 6(1)(f) – Legitimate interest</td>
        </tr>
        <tr>
          <td>Training machine learning models (opt-in only)</td>
          <td>Art. 6(1)(a) – Consent</td>
        </tr>
        </tbody>
      </table>

      <h2>5. Use of Machine Learning and AI Models</h2>
      <p>
        With explicit user consent, we may use anonymized and aggregated data (e.g., OTUs, metadata) to train internal machine learning and prediction models. These models help improve analytical accuracy and ecological inference.
      </p>
      <p>
        All training takes place on secure infrastructure within the European Union (AWS). No identifiable data is used without your opt-in.
      </p>

      <h2>6. Data Sharing and Processors</h2>
      <p>
        We do not sell or trade your data.
      </p>
      <p>
        Data is only shared with processors (e.g., AWS, analytics infrastructure providers) who act under our instructions and offer sufficient guarantees under Art. 28 GDPR.
      </p>

      <h2>7. Data Storage and Retention</h2>
      <ul>
        <li>Personal account data is stored as long as your account is active.</li>
        <li>Uploaded sequencing data and metadata are retained for the duration of your selected plan (sample-based or subscription), unless deleted by the user.</li>
        <li>Logs and access data are kept for a maximum of 12 months for security and diagnostic purposes.</li>
        <li>Upon account deletion, all user data will be deleted within 30 days, unless legal retention obligations apply.</li>
      </ul>

      <h2>8. Data Security</h2>
      <ul>
        <li>Encrypted data transmission (HTTPS)</li>
        <li>Role-based access controls</li>
        <li>Regular backups and monitoring</li>
        <li>Hosting on secure EU-based infrastructure (AWS Europe)</li>
      </ul>

      <h2>9. Your Rights under GDPR</h2>
      <ul>
        <li>Right to access (Art. 15 GDPR)</li>
        <li>Right to rectification (Art. 16 GDPR)</li>
        <li>Right to erasure (Art. 17 GDPR)</li>
        <li>Right to restriction of processing (Art. 18 GDPR)</li>
        <li>Right to data portability (Art. 20 GDPR)</li>
        <li>Right to object to processing (Art. 21 GDPR)</li>
        <li>Right to withdraw consent at any time (Art. 7(3) GDPR)</li>
        <li>Right to lodge a complaint with a supervisory authority (Art. 77 GDPR)</li>
      </ul>
      <strong><a href="https://www.saechsdsb.de/" target="_blank" rel="noopener noreferrer">Sächsischer Datenschutzbeauftragter</a></strong>

      <h2>10. Cookies and Tracking</h2>
      <p>
        spcfy uses only technically necessary cookies (e.g., for session management and login persistence). We do not use third-party marketing or tracking cookies.
      </p>

      <h2>11. Updates to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time to reflect legal, technical, or business developments. Changes will be announced on the platform and take effect upon publication.
      </p>

      <h2>12. Contact</h2>
      <p>
        For questions or requests regarding data protection, contact us at:<br />
        Email: <a href="mailto:info@spcfy.io">info@spcfy.io</a><br />
        Postal address: See Controller section above.
      </p>
    </>
  );
}